import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const OffertKategori = lazy(() => import("@/pages/info/OffertKategori"));

export const Route = createFileRoute("/kommersiella-batterier/")({
  head: () => seoHead("/kommersiella-batterier", { description: "Batterilager för företag och fastigheter – effekttoppskapning, stödtjänster och ökad egenanvändning av solel. Få kostnadsfria offerter." }),
  component: () => <OffertKategori slug="kommersiella-batterier" />,
});
